const shopifyAppUrl = "https://phillips-shopify.it-guy.tech";

const toggleClass = (element, className, add) => {
  if (add) {
    element.classList.add(className);
  } else {
    element.classList.remove(className);
  }
};

const addEventListener = (element, event, handler) => {
  element.addEventListener(event, handler);
};

const dispatchCustomEvent = (eventName) => {
  document.dispatchEvent(eventName);
};

const getSpanElements = (hamburger) =>
  hamburger.querySelectorAll("span[data-span]");

const getElement = (id) => document.getElementById(id);

const getElementsByClassName = (name) => document.getElementsByClassName(name);

const openSlider = (slider) => {
  toggleClass(slider, "-translate-x-full", false);
  toggleClass(slider, "translate-x-0", true);
};

const openBottomSlider = (slider) => {
  toggleClass(slider, "translate-y-full", false);
  toggleClass(slider, "translate-y-0", true);
};

const closeSlider = (slider) => {
  toggleClass(slider, "translate-x-0", false);
  toggleClass(slider, "-translate-x-full", true);
};

const closeBottomSlider = (slider) => {
  toggleClass(slider, "translate-y-full", true);
  toggleClass(slider, "translate-y-0", false);
};

document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll("a");
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      window.location.href = link.href;
    });
  });
});

const triggerToastMessage = (message, state, duration) => {
  console.log("dispatching event");
  const event = new CustomEvent("initiate-toast-event", {
    detail: {
      message: message,
      state: state,
      duration: duration || 3000,
    },
  });

  dispatchCustomEvent(event);
};

const toogleButtonLoader = (button, loader) => {
  if (loader.classList.contains("hidden")) {
    toggleClass(loader, "hidden", false);
    toggleClass(loader, "flex", true);
    button.disabled = true;
  } else {
    toggleClass(loader, "hidden", true);
    toggleClass(loader, "flex", false);
    button.disabled = false;
  }
};

function closePopup(id) {
  const element = getElement(id);
  toggleClass(element, "hidden", true);
  toggleClass(element, "flex", false);
}

function openPopup(id) {
  const element = getElement(id);
  toggleClass(element, "hidden", false);
  toggleClass(element, "flex", true);
}

function formatPriceINR(x) {
  // Remove currency symbol, commas and spaces
  x = x.replace(/Rs\.?/g, ''); // Remove "Rs" or "Rs."
  x = x.replace(/[₹,\s]/g, '');
  x = x.toString();
  var lastThree = x.substring(x.length - 3);
  var otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  var result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  // Add "Rs." with proper spacing
  result = "Rs. " + result;
  console.log(result);
  return result;
}

document
  .querySelector('a[href="#form"]')
  .addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector("#form").scrollIntoView({
      behavior: "smooth",
    });
  });
